import {Route} from "@angular/router";
import {VisitorsComponent} from "./visitors.cmp";

export const routes: Route[] = [
  {
    path: 'visitors',
    redirectTo: 'en/visitors',
    pathMatch: 'full'
  },
  {
    path: 'en/visitors',
    component: VisitorsComponent
  },
  {
    path: 'de/visitors',
    component: VisitorsComponent
  },
  {
    path: 'ro/visitors',
    component: VisitorsComponent
  }
]
